<!-- New create/edit button -->
<div edsGrid [ngClass]="{ 'has-edit-button': page?.isPreview() }">
  <!-- edit button -->
  <ng-container
    *ngIf="page?.isPreview()"
    [brManageContentButton]="document"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <!-- has content -->
  <div class="container container--wide" *ngIf="content">
    <div edsSpacing="lg">
      <!-- Pre Title -->
      <div edsRow *ngIf="displayParams?.preTitle">
        <div edsCol class="pre-title" edsSpacing="xs">
          <span>{{ displayParams?.preTitle }}</span>
        </div>
      </div>
      <!--Title  -->
      <div edsRow>
        <div edsCol>
          <eds-title
            *ngIf="displayParams?.title"
            size="h2"
            [isLight]="true"
            [title]="displayParams?.title"
            theme="dark"
            [edsSpacing]="displayParams?.enableViewMore ? 'none' : 'lg'"
          ></eds-title>
          <eds-link-item
            *ngIf="displayParams?.enableViewMore"
            [hasIcon]="true"
            [customIconClass]="'carrot-right'"
            [href]="viewMoreURL"
            [title]="viewMoreLabel"
            [hasTarget]="true"
            [forceRightAlign]="true"
            [forceTopAlignment]="true"
            eventId="linkOrButtonClick"
          ></eds-link-item>
        </div>
      </div>

      <!-- PLACEHOLDER Card Grid -->
      <ng-container *ngIf="content.articleContent?.length">
        <ng-container *ngIf="displayParams.displayStyle === 'ThreePerRow'">
          <div edsRow>
            <div
              edsCol
              edsSubGrid="layout-2"
              edsSubGridTablet="layout-1"
              edsSubGridGap="md"
              edsSubGridTabletGap="md"
            >
              <ng-container
                *ngFor="let article of content.articleContent; let i = index"
              >
                <ng-container *ngIf="displayParams?.maximumCards > i">
                  <div edsSpacing="lg">
                    <ng-container
                      *ngTemplateOutlet="
                        cardTemplete;
                        context: { article: article }
                      "
                    ></ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="displayParams.displayStyle === 'TwoLarge'">
          <div edsRow>
            <div
              edsCol
              edsSubGrid="layout-1"
              edsSubGridTablet="layout-1"
              edsSubGridGap="md"
              edsSubGridTabletGap="md"
            >
              <ng-container
                *ngFor="let article of content.articleContent; let i = index"
              >
                <ng-container *ngIf="i < 2">
                  <div edsSpacing="lg">
                    <ng-container
                      *ngTemplateOutlet="
                        cardTemplete;
                        context: { article: article }
                      "
                    ></ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div edsRow>
            <div
              edsCol
              edsSubGrid="layout-2"
              edsSubGridTablet="layout-1"
              edsSubGridGap="md"
              edsSubGridTabletGap="md"
            >
              <ng-container
                *ngFor="let article of content.articleContent; let i = index"
              >
                <ng-container *ngIf="i > 1">
                  <div edsSpacing="lg">
                    <ng-container
                      *ngTemplateOutlet="
                        cardTemplete;
                        context: { article: article }
                      "
                    ></ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="displayParams.displayStyle === 'ArticleCards'">
          <div edsRow>
            <div
              *ngFor="let article of content.articleContent"
              edsCol
              [columnNumbers]="{ s: 4, m: 3, l: 3 }"
            >
              <ng-container
                *ngTemplateOutlet="cardTemplete; context: { article: article }"
              ></ng-container>
            </div>
          </div>
        </ng-container>

        <ng-template let-article="article" #cardTemplete>
          <div>
            <eds-card-article
              [title]="article.title"
              [subTitle]="article.isArchive ? 'Archived' : ''"
              [date]="article.date"
              [imgSrc]="article.imgSrc"
              [href]="article.href"
              [description]="article.cardSummary"
              altText=""
              [hasImage]="article.imgSrc ? true : false"
              [isCompact]="false"
              [logoLink]="article.SIM?.logoSrc"
              [altLogoText]="article.SIM?.logoAltText | titlecase"
              [logoTheme]="article.SIM?.logoTheme"
              [logoBackgroundColor]="article.SIM?.logoBackgroundColor"
              [subTitle]="article.isArchived ? translationLabel?.archived : ''"
              [hasMediaTag]="article.mediaTag"
              [isMediaTagPodcast]="article.mediaTag?.type === 'Podcast'"
              [isMediaTagVideo]="article.mediaTag?.type === 'Video'"
              [mediaTagLabel]="article.mediaTag?.label"
            >
            </eds-card-article>
            <ft-insights-tags [insightsTags]="article"></ft-insights-tags>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <!-- No Document -->
  <div
    *ngIf="!content && page?.isPreview()"
    class="no-document"
    edsPadding
    [edsPaddingBottom]="padding"
    [edsPaddingTop]="padding"
    [edsSpacing]="marginBottom ? marginBottom : defaultMarginBottom"
  >
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>{{ componentLabel }}</strong>
      </div>
    </div>
  </div>
</div>
